// @flow
import React, { memo } from 'react'
import I18n from 'i18n-react'

import Option from './Options/Option'

import type { SelectItem } from '../../SelectEnumRefIndex'

type OptionsProps = {
  options: Array<SelectItem>,
  useDummyOption: boolean
}

const Options = ({ options, useDummyOption }: OptionsProps) => {
  return (
    <>
      {
        useDummyOption &&
        <option value={undefined}>{I18n.translate('stringEnum.placeholder')}</option>
      }

      {options.map((option, index) => (
        <Option key={index} option={option} index={index} />
      ))}
    </>
  )
}

export default memo(Options)
